@if (entry && fairId) { @if (entry.type === 'EXHIBITOR' ? entry.exhibitor : entry.brand; as item) { @if (entry &&
fairId) {
<div class="directory-item" [class]="{ highlighted: item.highlight && !isPlatformFair }">
  <div class="directory-item-teaser">
    <a
      class="directory-item-img"
      [routerLink]="
        entry.type === 'EXHIBITOR'
          ? ['/fairs', fairId, 'exhibitors', item.id]
          : ['/fairs', fairId, 'exhibitors', entry.brand.exhibitor?.id]
      ">
      @if (item?.image?.resource) {
      <img
        [src]="
          item.image.resource
            | ImageUrl : item.image.provider : { width: 60, height: 60, fileType: ImageFileTypes.WEBP }
        "
        [alt]="item.name"
        loading="lazy"
        class="logo" />
      } @else { @if(entry.type === 'BRAND') {
      <mat-icon class="logo__placeholder">shoppingmode</mat-icon>
      } @else {
      <mat-icon class="logo__placeholder">corporate_fare</mat-icon>
      } }
    </a>
    @if (size === 'phone') {
    <ng-container *ngTemplateOutlet="location"></ng-container>
    }
  </div>
  <a
    class="directory-item-description"
    [routerLink]="
      entry.type === 'EXHIBITOR'
        ? ['/fairs', fairId, 'exhibitors', item.id]
        : ['/fairs', fairId, 'exhibitors', entry.brand.exhibitor?.id]
    ">
    <div class="directory-item-details">
      <h2 class="directory-name">{{ item.name }}</h2>
      @if (size !== 'phone') {
      <ng-container *ngTemplateOutlet="typeHint"></ng-container>
      }
    </div>
  </a>
  <div class="directory__meta">
    @if (size !== 'phone') {
    <ng-container *ngTemplateOutlet="location"></ng-container>
    <ng-container *ngTemplateOutlet="actions"></ng-container>
    } @if (size === 'phone') { @if (isPlatformFair) {
    <span class="directory__chip mat-caption directory__chip--placeholder"></span>
    }
    <ng-container *ngTemplateOutlet="typeHint"></ng-container>
    <ng-container *ngTemplateOutlet="actions"></ng-container>
    }
  </div>
  <ng-template #typeHint>
    @if (!isPlatformFair) {
    <div class="directory__typehint">
      @if (entry.type === 'EXHIBITOR') { @if (item.booth?.exhibitor_type === type.ha) {
      <span
        class="directory__chip mat-caption"
        [class.directory__chip--highlighted]="item.highlight"
        [class.meta--typehint]="size === 'phone'"
        i18n="@@featureExhibitorDirectory-mother">
        Hauptaussteller
      </span>
      } @if (item.booth?.exhibitor_type !== type.ha) {
      <span
        class="directory__chip mat-caption"
        [class.directory__chip--highlighted]="item.highlight"
        [class.meta--typehint]="size === 'phone'"
        i18n="@@featureExhibitorDirectory-child">
        Mitaussteller
      </span>
      } } @else { @if (entry.type === 'BRAND') {
      <div class="directory__typehinttext mat-caption" i18n="@@featureExhibitorDirectory-brandOf">
        <span class="directory__typehinttext--uppercase">Marke</span>
        von {{ entry.brand.exhibitor?.name }}</div
      >
      } } @if ( entry.type === 'EXHIBITOR' ? entry.exhibitor.flags.includes(ExhibitorSearchResultFlags.startup) : false
      ) {
      <div class="directory__startup">
        <span class="directory__startupdivider"></span>
        <span class="directory__startupitem">
          <mat-icon
            matTooltip="Startup"
            matTooltipClass="bau365-tooltip directory__startuptooltip"
            matTooltipPosition="above"
            #tooltip="matTooltip"
            (mouseenter)="tooltip.toggle()"
            (mouseleave)="tooltip.toggle()"
            (touchstart)="tooltip.toggle()"
            (touchend)="tooltip.toggle()"
            i18n-matTooltip="@@featureExhibitorDirectory-startup-tooltip"
            >rocket_launch</mat-icon
          >
          <span i18n="@@featureExhibitorDirectory-startup" class="mat-caption">Startup</span>
        </span>
      </div>
      }
    </div>
    } @else { @if (entry.type === 'BRAND') {
    <div class="directory__typehinttext mat-caption" i18n="@@featureExhibitorDirectory-brandOf">
      <span class="directory__typehinttext--uppercase">Marke</span>
      von {{ entry.brand.exhibitor?.name }}</div
    >
    } }
  </ng-template>
  <ng-template #location>
    @if ((hallPlanToggle$ | async) && !isPlatformFair && (hallPlanActive$ | async)) { @if (item.booth) {
    <planone-location
      [exhibition_halls]="[
        {
          id: item.booth.hall_id ?? '',
          name: item.booth.hall_name,
          fair_id: item.booth.fair_id ?? fairId,
          booths: [{ name: item.booth.name }]
        }
      ]"
      [fair_id]="fairId"
      [inverted]="item.highlight"></planone-location>
    } }
  </ng-template>
  <ng-template #actions>
    <button mat-icon-button class="action meta--share" (click)="openShareButtonDialog($event)">
      <mat-icon class="action__icon">share</mat-icon>
    </button>
    @if (watchlistEnabled) {
    <bau365-toggle-watchlist-item
      class="action__watchlisticon meta--watchlist"
      [entityType]="entry.type"
      [entityId]="item.id"
      [pageContext]="'exhibitors'"
      [fairId]="fairId"></bau365-toggle-watchlist-item>
    } @else {
    <div class="action action--placeholder"></div>
    } @if (entry.type === 'EXHIBITOR') {
    <bau365-channel-subscribe-button
      class="meta--subscribe"
      [fairId]="fairId"
      [entityId]="entry.exhibitor.id"
      [context]="'exhibitor-directory'"></bau365-channel-subscribe-button>
    }
  </ng-template>
</div>
}
<ng-template #shareButtonsTitle>
  <span i18n="@@featureSearch-resultTeaser-socialShareTitle">Teilen</span>
</ng-template>
<ng-template #shareButtons>
  <planone-share-buttons
    [url]="url"
    [disabledProvider]="['print']"
    [emailSubject]="emailSubject"
    [emailBody]="emailBody"
    (shareButtonClicked)="shareButtonClick($event)"></planone-share-buttons>
</ng-template>
} }
